var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _ellipse, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1488.189 992.126 1275 850",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1488.189 992.126h1275v850h-1275z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#369443",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1885.935 1567.623s-1.033-6.99 12.242-12.116c13.275-5.126 14.307-24.232 11.652-36.97 0 0-6.932 12.116-15.339 16.155 0 0-13.717 7.146-14.345 20.795 0 0-.109 4.99-1.142 8.873-.565 2.126-6.637-17.087 4.867-31.377 11.872-14.748 15.192-26.717 5.752-50.017 0 0-.885 14.135-10.177 22.213-9.292 8.077-10.474 8.699-10.325 27.96 0 0 .148 6.679-3.392 8.854 0 0-7.227-10.563-9.145-17.553-1.917-6.99-2.802-9.941 5.457-18.019 0 0 26.461-17.1 7.375-54.522 0 0-.59 12.893-9.735 20.504-9.145 7.611-8.407 12.737-8.85 25.941-.443 13.203-1.328 12.271-2.36 14.135 0 0-16.814-30.911-3.835-47.377s20.207-19.883 5.9-50.483c0 0 .635 15.689-10.818 23.456-11.453 7.767-8.798 25.941-8.798 25.941s.737 6.835-1.622 11.805c0 0-16.202-31.601-.737-48.62 13.127-14.446 14.012-24.543 6.932-45.047 0 0-.885 9.476-8.112 14.601-7.227 5.126-12.979 10.252-11.652 29.979 0 0 .59 13.825-1.18 17.708 0 0-6.785-12.582-8.702-20.815-1.917-8.233-2.655-13.048 2.36-21.281 5.015-8.233 24.927-31.844 1.18-65.861 0 0-.737 11.029-6.785 20.97-6.047 9.941-3.245 21.747-1.917 30.756s-3.097 17.708-3.097 17.708-10.325-18.951-8.112-40.697c2.212-21.747-6.637-39.61-26.697-52.503 0 0-14.602 33.863 5.31 51.105 0 0 16.962 16.776 21.239 37.125 0 0-12.832-1.243-24.484-23.921-11.652-22.679-35.841-19.106-37.464-19.261 0 0 3.983 35.105 41.151 45.047 0 0 23.747 4.039 28.172 21.436 0 0 3.982 11.961 5.605 18.329 0 0-7.522-2.951-14.455-13.203-6.932-10.252-6.047-11.495-29.499-13.825 0 0-9.44-1.088-14.455-7.767 0 0 9.882 37.125 35.251 36.814 0 0 23.157-2.485 36.136 27.96 0 0-2.507-1.553-5.9-3.884-3.392-2.33-11.947-6.679-28.909-4.66s-21.682-.777-25.959-2.175c0 0 17.109 31.377 41.299 22.057 24.189-9.32 35.872 24.665 36.136 25.319 0 0-3.245-2.486-7.522-6.68-4.277-4.194-13.157-9.366-29.942-4.039 0 0-12.094 4.66-24.337.932 0 0 11.8 22.834 39.381 18.951 27.581-3.884 34.514 20.349 34.514 20.349s-3.687-2.175-6.195-4.194c-2.507-2.019-11.8-7.301-31.711-1.398-19.912 5.903-27.139-.932-27.139-.932s11.062 20.193 32.301 22.523c0 0 11.8-.155 16.814-2.019 5.015-1.864 18.289-4.815 27.434 8.388 0 0-2.507.466-6.342-1.243 0 0-14.159-5.126-24.927 3.883 0 0-9.587 9.786-23.157 7.922 0 0 17.552 17.087 45.428 2.641 0 0 9.44-6.835 16.372-1.553 6.934 5.285 23.011-5.123 23.011-5.123z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2041.1 1146.669s-3.238-28.908 19.863-31.688c24.091-2.9 35.989 2.175 35.989 2.175l10.816 21.229-3.737 14.291-14.946 6.835s2.557-21.954-17.568-22.411c-5.099-.116-8.096 1.906-16.161.626-8.111-1.288-12.449 7.625-14.256 8.943z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2203.639 1218.226c-3.442 4.453-17.208 6.006-17.208 6.006s14.159 10.873 20.256 26.407c6.097 15.533-164.113.103-164.113.103s7.375-5.281 12.39-15.223c0 0-7.522 2.796-15.044-4.66 0 0 5.605 1.864 12.979-9.32 0 0 10.915-13.98 18.584-17.708 0 0-3.54 2.175-12.094-2.485 0 0 14.75-1.864 20.059-27.028 0 0 .885-5.592 6.49-13.669 5.605-8.078 4.425 1.553 14.75-10.874 0 0 4.72-8.802.59-14.187s-8.555-3.417-17.208-8.595c-8.653-5.178-12.488-8.078-9.538-16.051 2.95-7.974 10.62-6.731 11.701-6.731 1.082 0 1.672-6.938 11.112-11.702s34.514-2.693 38.25-.621c3.737 2.071 18.879 6.524 27.729 28.892 8.85 22.368-2.36 30.756 21.731 64.515 0 0-9.636 2.071-15.831.207 0 0 12.487 22.161 34.415 32.724z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2098.328 1123.835c-19.617-.932-12.094-19.624-12.094-19.624"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2132.399 1126.398s-3.466-1.631-6.398-5.514c-4.115-5.449-13.292-8.077-18.233-2.951 0 0-5.015 5.592-9.44 5.903 0 0 5.015 1.553 8.481 4.738 3.466 3.184 7.08 5.514 12.242 4.815 5.162-.699 5.974-3.417 8.407-5.048 2.434-1.633 4.941-1.943 4.941-1.943z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2259.981 1405.765s18.29 14.912 33.629 0c0 0 6.195 7.456 18.584 5.281 12.39-2.175 14.455-8.699 15.635-12.427 0 0 10.718 6.253 19.764 1.314 9.047-4.939 9.047-12.394 9.047-12.394s15.733 3.101 23.796-7.562c8.063-10.663 3.147-21.226-1.18-22.469 0 0 17.01 4.456 21.633-10.148 3.933-12.427-4.917-18.847-4.917-18.847s35.841-.172 50.542-11.391c0 0 12.193-7.663 4.917-15.74 0 0 32.252-5.178 40.315-18.019 0 0 3.54-3.521 2.36-9.734 0 0-.197-3.521-3.737-3.728 0 0 36.78-5.681 47.395-17.812 0 0 5.113-5.592 2.557-13.048 0 0-.541-1.968-1.426-3.288 0 0 33.481-7.068 50-21.98 0 0 9.536-8.496 4.62-19.887 0 0 55.951-15.322 42.972-39.968 0 0 26.156-8.492 17.896-32.102 0 0 21.633-10.977 12.193-28.374-9.034-16.65-36.775 2.899-69.624 11.988 0 0-88.884 27.985-132.656 35.432l-124.372 185.167-72.568 27.96-7.375 51.776z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2259.097 1269.382s11.657-8.751 32.449 1.553c0 0 7 4.82 12.507-.461 4.601-4.413 5.032-12.549-1.297-17.247-15.487-11.495-21.24-45.979 2.36-60.269 0 0 34.219-20.297 159.696-52.229 0 0 10.513-2.915 16.118-1.517 6.172 1.539 10.423 6.835 11.295 11.366 0 0 5.615 15.956-13.262 25.086 0 0-8.522 3.9-17.306 6.421 0 0 9.648-2.086 13.766 7.456 3.933 9.113-1.77 18.433-19.469 24.439 0 0-4.787 1.863-11.603 3.521 0 0 15.143 4.349 7.866 16.569 0 0-6.49 12.841-29.401 15.119 0 0 17.109 1.864 5.015 18.122 0 0-5.31 8.906-22.026 12.22 0 0 12.685.414 6.293 11.805-6.391 11.391-21.432 17.812-36.232 18.847 0 0-8.016.414-13.621-.829 0 0 14.061 7.042 5.801 18.847 0 0-6.096 8.388-21.337 7.974 0 0 3.956 13.183-7.227 18.174-8.702 3.883-15.929-2.33-15.929-2.33s2.95 14.135-9.735 19.106c0 0-6.342 3.262-15.782 0 0 0-7.227 16.155-32.891 4.815-25.666-11.338-6.048-106.558-6.048-106.558z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2654.383 1121.815s-40.315 23.342-165.869 46.684"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M1934.384 1534.589s-14.946 25.682-33.039 26.096c0 0-31.122-3.788-39.922 4.349-6.136 5.675-12.39 10.356-14.946 24.854s4.916 17.605 6.686 18.226c0 0 1.377 10.356 11.603 7.663 0 0 .59 10.77 18.683 5.592s25.566-3.521 29.106-21.54c3.54-18.019 6.808-17.724 10.03-19.883 4.327-2.9 12.455-5.64 18.486-9.113 5.418-3.12 26.156-13.67 33.235-14.498 7.08-.828 5.506-24.646 5.506-24.646h-18.289l-8.85-13.048-18.289 15.948z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2636.487 1153.918s-109.115 35.594-159.93 39.968m116.958 0s-64.011 20.094-138.971 32.774m84.35 9.093s-72.322 17.372-106.849 20.255"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2490.368 1269.9s-61.173 12.758-76.672 14.292"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2421.511 1362.939l3.063 97.066h0l-17.139-9.943h0l-28.534 123.179-11.773-8.458 27.776-118.011h0l-19.368.356h0z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2451.43 1301.381s-44.642 6.783-62.409 6.42m6.951 20.712s-18.05-.848-26.724-2.288m10.007 31.284s-15.34-4.142-24.386-9.941m1.771 39.972s-11.8-4.556-17.503-16.983m-11.308 28.063s-9.145-8.181-9.735-17.294"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2532.37 1406.102l-40.565 87.218h0l-10.701-17.253h0l-85.643 101.197-9.273-10.381 85.318-99.916h0l-17.259-9.262h0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2293.61 1405.765s3.424-2.953 1.082-15.792"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2495.369 1342.078l-20.896 94.594h0l-14.112-14.276h0l-76.651 147.389-11.812-6.895 77.167-147.088h0l-18.795-4.935h0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2298.035 1371.126s1.77-3.676 1.18-9.475"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M1991.986 1405.766s-18.289 14.912-33.629 0c0 0-6.195 7.456-18.584 5.281s-14.455-8.699-15.635-12.427c0 0-10.718 6.253-19.764 1.314-9.047-4.939-9.047-12.395-9.047-12.395s-15.733 3.101-23.796-7.562c-8.063-10.663-3.147-21.226 1.18-22.469 0 0-17.01 4.456-21.633-10.148-3.933-12.427 4.917-18.847 4.917-18.847s-35.841-.172-50.542-11.391c0 0-12.193-7.663-4.916-15.74 0 0-32.252-5.178-40.315-18.019 0 0-3.54-3.521-2.36-9.734 0 0 .197-3.521 3.736-3.728 0 0-36.78-5.681-47.395-17.812 0 0-5.113-5.592-2.557-13.048 0 0 .541-1.968 1.426-3.288 0 0-33.481-7.068-50.001-21.98 0 0-9.536-8.496-4.62-19.887 0 0-55.952-15.322-42.972-39.968 0 0-26.156-8.492-17.896-32.102 0 0-21.633-10.977-12.193-28.374 9.034-16.65 36.776 2.899 69.624 11.988 0 0 88.884 27.985 132.656 35.432l124.372 185.167 72.568 27.96 7.376 51.777z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2362.54 1187.263s-20.649 8.285-27.532 19.676c-6.883 11.391-2.35 22.462 0 28.814 1.181 3.192 15.733 31.248-1.377 51.545"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M1992.871 1269.383s-11.657-8.751-32.449 1.553c0 0-7 4.82-12.506-.461-4.601-4.413-5.033-12.549 1.297-17.247 15.487-11.495 21.239-45.979-2.36-60.269 0 0-34.219-20.297-159.696-52.229 0 0-10.513-2.915-16.118-1.517-6.172 1.539-10.423 6.835-11.295 11.366 0 0-5.615 15.956 13.262 25.086 0 0 8.522 3.9 17.306 6.421 0 0-9.648-2.086-13.766 7.456-3.933 9.113 1.77 18.433 19.469 24.439 0 0 4.787 1.863 11.603 3.521 0 0-15.143 4.349-7.866 16.569 0 0 6.49 12.841 29.401 15.119 0 0-17.109 1.864-5.015 18.122 0 0 5.31 8.906 22.026 12.22 0 0-12.685.414-6.293 11.805 6.391 11.391 21.432 17.812 36.233 18.847 0 0 8.016.414 13.621-.828 0 0-14.061 7.042-5.801 18.847 0 0 6.096 8.388 21.338 7.974 0 0-3.956 13.184 7.227 18.174 8.702 3.883 15.929-2.33 15.929-2.33s-2.95 14.135 9.735 19.106c0 0 6.342 3.262 15.782 0 0 0 7.227 16.155 32.891 4.815 25.662-11.34 6.045-106.559 6.045-106.559z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2362.245 1309.355s-.098-.104-7.375-2.382m50.935-27.442s-12.308 2.478-24.386 2.589m41.397-32.931s-14.455 1.45-28.024 1.243m49.558-32.931s-20.846 4.142-32.056 4.349m49.362-39.765s-25.709 7.338-44.839 9.941m-42.478 15.119s18.486 17.19-3.737 33.138c0 0 9.243 14.498-9.243 29.617"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M1994.394 1416.2s-3.766 20.218-33.627 45.666c0 0-23.04 20.324-22.45 43.727.601 23.832-4.13 26.51-13.176 34.588 0 0 18.683 1.45 27.729-10.977 0 0-.393 20.711-3.147 22.575 0 0 5.859.374 14.356-8.906 0 0 5.113-5.385 9.833-7.456 0 0-5.506 14.291-1.18 27.546 0 0 1.377-5.178 8.653-7.456 0 0 13.176-2.693 18.29-21.747 0 0 3.343-12.634 23.992-23.818 0 0 23.402-8.827 22.813-20.361s-52.086-73.381-52.086-73.381z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2366.276 1277.046s2.753 27.646-31.072 27.648c0 0 6.49 24.647-26.156 23.819 0 0-3.737 19.675-27.336 15.74"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2317.618 1534.589s14.946 25.682 33.039 26.096c0 0 31.122-3.788 39.922 4.349 6.136 5.675 12.39 10.356 14.946 24.854 2.557 14.498-4.917 17.604-6.687 18.226 0 0-1.377 10.356-11.603 7.663 0 0-.59 10.77-18.683 5.592s-25.566-3.521-29.106-21.54c-3.54-18.019-6.808-17.724-10.03-19.883-4.327-2.9-12.455-5.64-18.486-9.113-5.418-3.12-26.156-13.669-33.235-14.498-7.08-.828-5.507-24.646-5.507-24.646h18.289l8.85-13.048 18.291 15.948z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2257.608 1416.2s3.766 20.218 33.627 45.666c0 0 23.04 20.324 22.45 43.727-.601 23.832 4.13 26.51 13.176 34.588 0 0-18.683 1.45-27.729-10.977 0 0 .393 20.711 3.147 22.575 0 0-5.86.374-14.356-8.906 0 0-5.113-5.385-9.833-7.456 0 0 5.506 14.291 1.18 27.546 0 0-1.377-5.178-8.653-7.456 0 0-13.176-2.692-18.29-21.747 0 0-3.343-12.634-23.992-23.818 0 0-23.403-8.827-22.813-20.361.59-11.534 52.086-73.381 52.086-73.381z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2333.695 1560.685s5.352 1.191 16.962 0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2383.303 1575.183s16.323-2.485 15.536 32.931m-25.369-24.854s14.75-1.864 13.766 32.517"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2231.088 1500.416s7.08 1.45 11.997 7.042c4.916 5.592 14.356 4.556 14.356 4.556s-5.113-4.142-6.883-14.498-7.473-13.462-7.473-13.462m16.889-9.807s7.08 1.45 11.996 7.042 14.356 4.556 14.356 4.556-5.113-4.142-6.883-14.498-7.473-13.462-7.473-13.462m-7.128 56.562s6.182 1.266 10.474 6.149c4.293 4.882 12.535 3.978 12.535 3.978s-4.465-3.617-6.01-12.658c-1.545-9.042-6.525-11.754-6.525-11.754"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2149.136 1676.875s5.361 23.657 23.993 21.747c0 0 13.176-1.243 12.193-23.197 0 0 19.469 10.356 22.616-15.326 0 0 17.699 4.142 17.503-19.883 0 0 16.52 2.9 14.553-18.433 0 0 17.896 4.763 17.896-15.326 0 0 41.888-6.947-45.428-86.573l-77.877 46.393 14.551 110.598z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2140.483 1570.709s12.979 11.516 22.222-5.675c0 0 12.586-.621 14.553-10.148 0 0 10.227-1.036 12.193-10.77 0 0 13.963-1.45 13.57-13.255 0 0 25.385-1.96.008-30.7-25.377-28.741-68.446 47.684-68.446 47.684l5.9 22.864z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2185.322 1675.425s-1.967-41.63-38.047-101.278m60.663 85.952s5.605-24.025-45.232-95.064c0 0 5.9-16.983-12.193-27.857m74.927 103.038s1.573-25.993-48.181-85.33c0 0 4.395-15.326-13.634-27.546m76.368 94.443s-1.868-26.303-50.542-77.667c0 0 2.435-15.74-15.007-25.475m83.445 87.816s-3.54-30.031-54.868-75.596c0 0 1.77-11.805-15.34-23.818"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2102.865 1676.875s-5.361 23.657-23.992 21.747c0 0-13.176-1.243-12.193-23.197 0 0-19.469 10.356-22.616-15.326 0 0-17.699 4.142-17.503-19.883 0 0-16.52 2.9-14.553-18.433 0 0-17.896 4.764-17.896-15.326 0 0-41.888-6.947 45.428-86.573l77.877 46.393-14.552 110.598z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2111.519 1570.709s-12.979 11.516-22.223-5.674c0 0-12.586-.621-14.552-10.148 0 0-10.227-1.036-12.193-10.77 0 0-13.963-1.45-13.57-13.255 0 0-25.385-1.96-.008-30.7 25.377-28.741 68.446 47.683 68.446 47.683l-5.9 22.864z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2066.68 1675.425s1.966-41.63 38.047-101.278m-60.663 85.952s-5.605-24.025 45.232-95.064c0 0-5.9-16.983 12.193-27.856"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2126.001 1563.585c12.582 0 26.839 78.599 23.139 125.953-1.344 17.198-10.557 31.245-23.139 31.245s-21.795-14.047-23.139-31.245c-3.7-47.354 10.557-125.953 23.139-125.953"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2026.561 1640.216s-1.573-25.993 48.182-85.33c0 0-4.395-15.326 13.634-27.546m-76.369 94.443s1.868-26.303 50.542-77.667c0 0-2.435-15.74 15.007-25.475"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F4C53D",
    stroke: "#010002",
    strokeWidth: 3,
    cx: 2126.001,
    cy: 1562.963,
    rx: 17.41,
    ry: 25.785
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1994.112 1606.457s3.54-30.031 54.868-75.596c0 0-1.77-11.805 15.34-23.818"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2126.001 1557.331s147.66-65.433 148.029-216.805h-296.058c.369 151.372 148.029 216.805 148.029 216.805z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2046.293 1340.525h22.774m-68.321 0h22.774m68.321 0h22.773"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#A60032",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2000.746 1340.525v96.719s11.31 22.432 22.774 36.5v-133.219h-22.774 0zm45.547 0v159.435s14.242 13.965 22.774 20.697v-180.132h-22.774zm45.548 0v197.076s16.248 10.494 22.774 13.937v-211.013h-22.774z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2000.746 1340.525h22.774m22.773 0h22.774m22.774 0h22.773"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#A60032",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2251.256 1340.525v96.719s-11.31 22.432-22.773 36.5v-133.219h22.773zm-45.548 0v159.435s-14.242 13.965-22.774 20.697v-180.132h22.774zm-45.547 0v197.076s-16.248 10.494-22.774 13.937v-211.013h22.774z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2281.978 1703.708l-13.717 16.776m-17.005-18.639l37.801 34.948"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2364.725 1614.728l-5.742 23.475h0l15.719 15.659h0l-22.216 93.839-19.76-26.542-29.279 13.665 22.216-93.839h0l20.597-5.743h0l5.348-23.433s6.23-2.44 13.117 2.919z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2369.988 1599.248l-11.315 21.11h0l11.335 19.41h0l-44.521 84.586-12.564-31.023-31.64 5.219 44.521-84.586h0l21.306.067h0l10.924-21.177c.001 0 7.948-.017 11.954 6.394z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2371.898 1605.387l-30.096 38.235h0l6.898 21.598h0l-61.447 71.871-5.615-33.205-31.943-2.411 61.447-71.871h0l20.746 5.113h0l31.924-40.59c-.001.001 8.561 4.253 8.086 11.26z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M1597.585 1121.816s40.315 23.342 165.869 46.684m-147.973-14.582s109.115 35.594 159.93 39.968m-116.958 0s64.011 20.094 138.971 32.774m-84.351 9.093s72.322 17.371 106.849 20.255"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1761.599 1269.901s61.173 12.758 76.672 14.292m-37.733 17.189s44.642 6.783 62.409 6.42m-6.951 20.711s18.05-.848 26.724-2.288m-10.008 31.284s15.34-4.142 24.386-9.941m-1.77 39.972s11.8-4.556 17.503-16.983m11.308 28.064s9.145-8.181 9.735-17.294m24.484 24.439s-3.424-2.953-1.082-15.792m-3.343-18.848s-1.77-3.676-1.18-9.475m-63.325-174.388s20.649 8.284 27.532 19.675c6.883 11.391 2.35 22.462 0 28.814-1.181 3.192-15.733 31.248 1.377 51.545m-28.614 22.058s.098-.104 7.375-2.382m-50.935-27.442s12.308 2.478 24.386 2.589m-41.397-32.931s14.455 1.45 28.024 1.243"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#369443",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1882.877 1610.513s-.442-12.581 15.486-13.513l46.901 65.237s-1.77 4.194-23.008 3.728c0 0-2.249-.015-3.429 2.47-1.812 3.815-35.95-57.922-35.95-57.922z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1807.618 1217.501s20.846 4.142 32.056 4.349m-49.362-39.765s25.709 7.338 44.839 9.941m42.478 15.12s-18.486 17.19 3.736 33.138c0 0-9.243 14.498 9.243 29.617m-4.916 7.146s-2.753 27.646 31.072 27.648c0 0-6.49 24.647 26.156 23.819 0 0 3.736 19.676 27.336 15.74"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M1918.258 1560.685s-5.352 1.191-16.962 0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1868.651 1575.183s-16.323-2.485-15.536 32.931m25.369-24.854s-14.75-1.864-13.766 32.516"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010002",
    strokeWidth: 3,
    d: "M2020.914 1500.415s-7.08 1.45-11.996 7.042-14.356 4.556-14.356 4.556 5.113-4.142 6.883-14.498 7.473-13.462 7.473-13.462m-16.89-9.806s-7.08 1.45-11.996 7.042-14.356 4.556-14.356 4.556 5.113-4.142 6.883-14.498 7.473-13.462 7.473-13.462m7.128 56.561s-6.182 1.266-10.474 6.148c-4.293 4.883-12.535 3.978-12.535 3.978s4.465-3.617 6.01-12.659c1.545-9.042 6.525-11.754 6.525-11.754"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#162667",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M2274.03 1230.549s-72.456 37.901-148.029-3.107c-75.573 41.008-148.029 3.107-148.029 3.107v109.976h296.058v-109.976h0z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    stroke: "#010002",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1609.306 1515.748c7.175-2.929 12.342-5.756 12.32-13.412-.005-1.825-1.019-5.863-3.055-12.114l-48.177-147.24c-2.853-8.747-5.01-13.947-6.01-15.863-2.166-4.147-6.417-5.835-12.143-8.22h61.232c-6.652 3.143-12.716 5.639-12.659 12.691.022 2.693.779 6.49 2.341 11.393l36.907 115.541 36.871-115.541c1.562-4.903 2.369-8.7 2.343-11.393-.071-7.248-6.386-9.86-12.591-12.691h59.343c-5.426 2.174-9.848 3.878-12.12 8.22-1.002 1.916-3.157 7.116-6.009 15.863l-48.177 147.24c-2.038 6.25-2.775 10.357-3.056 12.258 0 0-2.217 9.312 12.32 13.267l-59.68.001h0zm1026.68-15.143v-166.709c0-2.884-.476-5.095-1.425-6.634-.951-1.537-5.09-5.969-10.995-8.364h55.175c-5.906 1.955-10.046 6.706-10.995 8.292-.951 1.586-1.425 3.821-1.425 6.706v166.709c0 2.981.491 5.264 1.476 6.85.983 1.586 5.039 5.458 10.944 8.292h-55.175c5.906-2.687 10.044-6.825 10.995-8.364.949-1.536 1.425-3.797 1.425-6.778z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/vi.6b5c07f8d63d70a502b2cfe31e8add9c.svg";
export { ForwardRef as ReactComponent };